import type { App } from "vue";
import { trackEvent } from "../Types/Analytics";

export const TagManager = ( app: App<any> ) => 
{
    return app.directive( "tag", {
        mounted: ( el: HTMLElement, binding: any ) =>
        {
            el.addEventListener( 'click', () =>
            {
                trackEvent( `Click | ${binding.value}` );
            } );
        },
    } );
};
